/**
 * Reveal the hidden additional questions heading of the quote request
 * form once we transition to the "additional questions" phase.
 */
function initializeAdditionalQuestions() {
	const headingElement = this.wrapperElement.querySelector('.quote-request-form__additional-questions-heading');

	if (headingElement) {
		headingElement.classList.replace('js-hide', 'quote-request-form__step--fade-in');
	}
}

export {
	initializeAdditionalQuestions
}